import React from "react";
import { faqContent } from "../data/data";

const FAQ = () => {
  return (
    <>
      <section id="faq" className="container-fluid container--faq">
        <div className="section-width">
        <div className="section-title-wrapper">
          <h5 className="section-title text-center">
            Frequently Asked Questions
          </h5>
        </div>
        <div className="section-content-wrapper">
          <div
            className="accordion accordian-flush accordian--faq"
            id="accordion-faq"
          >
            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingOne"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  What subjects do you offer tuition for?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  We offer personalized home tuition for all major subjects
                  including Math, Science, English, Social Studies, and optional
                  languages from Grades 1 to 12 (CBSE, ICSE, State Board).
                  Subject availability may vary by grade.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingTwo"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Who are the tutors?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  Our tutors are qualified and experienced educators, subject
                  matter experts, or trained professionals with a strong
                  academic background and a passion for teaching.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingThree"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  What is the duration and frequency of each class?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  Typically, each session lasts 1 to 1.5 hours. Frequency is
                  flexible—usually 2 to 5 classes per week depending on the
                  student’s need and availability.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingFour"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Do you offer one-on-one tuition or group classes?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  We offer both one-on-one personalized classes and small group
                  sessions (2–4 students) based on the parent's preference and
                  student requirements.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingFive"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Can I request a trial class?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  Yes, we offer one free trial class so that you can assess the
                  teaching quality before enrolling.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingSix"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseSix"
                  aria-expanded="false"
                  aria-controls="flush-collapseSix"
                >
                  What is the fee structure?
                </button>
              </h2>
              <div
                id="flush-collapseSix"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingSix"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  The fee depends on the class level, subject(s), and number of
                  sessions per month. Please contact us directly for a
                  customized fee quote.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingSeven"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseSeven"
                  aria-expanded="false"
                  aria-controls="flush-collapseSeven"
                >
                  Is there any registration fee or hidden charges?
                </button>
              </h2>
              <div
                id="flush-collapseSeven"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingSeven"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  No, we do not charge any registration fees or have hidden
                  costs. You pay only for the tuition sessions you choose.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingEight"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseEight"
                  aria-expanded="false"
                  aria-controls="flush-collapseEight"
                >
                  How do you ensure the quality of teaching?
                </button>
              </h2>
              <div
                id="flush-collapseEight"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingEight"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  We regularly monitor tutor performance, gather feedback from
                  parents/students, and conduct academic assessments to ensure
                  consistent learning outcomes.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingNine"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseNine"
                  aria-expanded="false"
                  aria-controls="flush-collapseNine"
                >
                  What if I want to change the tutor later?
                </button>
              </h2>
              <div
                id="flush-collapseNine"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingNine"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  You can request a tutor change anytime if you're not
                  satisfied. We’ll do our best to assign another suitable tutor
                  quickly.
                </div>
              </div>
            </div>

            <div className="accordion-item accordian-item--faq">
              <h2
                className="accordion-header accordian-header--faq"
                id="flush-headingTen"
              >
                <button
                  className="accordion-button accordian-btn--faq collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTen"
                  aria-expanded="false"
                  aria-controls="flush-collapseTen"
                >
                  Do you provide online classes as well?
                </button>
              </h2>
              <div
                id="flush-collapseTen"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTen"
                data-bs-parent="#accordion-faq"
              >
                <div className="accordion-body accordian-body--faq__answer">
                  Yes, we offer both in-person and online classes to cater to
                  your convenience and preferences."
                </div>
              </div>
            </div>
          </div>
        </div>

        </div>
      </section>
    </>
  );
};
export default FAQ;
